import MagneticElement from '../@tix02/dom/MagneticElement';
import { select } from '../@tix02/utility/dom';

export default () => {
	const logo = select('.site-credits').first;
	if( logo ) {
		new MagneticElement(logo);
	}
};